/** @type {import('../help-index.js').HelpSidebarItem} */
export const LAB_LSD_CONFIG_ITEM = {
  id: 'lsd_config_sidebar',
  screenId: 'lab-lsd-config',
  label: 'Configuración',
  description: 'Catálogos AFIP: obras sociales y conceptos para el LSD.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Habilitás en tu empresa los códigos oficiales de AFIP que usa el Libro de Sueldos Digital: obras sociales y conceptos de liquidación. Esos códigos se vinculan después en Empleados, Conceptos y al exportar el TXT.',
      },
      {
        title: 'Pestañas',
        bullets: [
          'Obras sociales — códigos AFIP de obra social (registro 04 / F.931).',
          'Conceptos AFIP — códigos oficiales para vincular en Laboral → Conceptos (relación empleador ↔ ARCA).',
        ],
      },
      {
        title: 'TXT relación de conceptos',
        paragraphs: [
          'Botón «Descargar TXT relación de conceptos»: archivo de alta en AFIP (no es por empleado ni por período).',
          'Cada línea une código ARCA + código LSD del empleador + marcas de qué bases suman (SIPA, obra social/rem 4 y 8, ART, etc.).',
          'Requiere que los conceptos activos tengan código LSD y concepto AFIP. Subilo una vez en AFIP (y de nuevo si agregás o cambiás conceptos).',
        ],
      },
      {
        title: 'Paso 1 — Ver el listado',
        bullets: [
          'Interruptor «Solo … habilitados» — activo por defecto; desmarcá para ver deshabilitados.',
          'Obras sociales: columnas Código AFIP, Descripción, Habilitado.',
          'Conceptos AFIP: columnas Código AFIP, Descripción, Tipo (Remunerativo / No remunerativo / Descuento), Habilitado.',
          'Podés exportar la lista. Tocá una fila para editar.',
        ],
      },
      {
        title: 'Paso 2 — Agregar del catálogo AFIP',
        intro: 'Botón +. En la ventana:',
        fields: [
          {
            label: 'Buscador del catálogo AFIP',
            description: 'Escribí al menos 3 caracteres (nombre o código). Elegí un ítem de la lista; el código AFIP se completa solo.',
          },
          { label: 'Código AFIP', description: 'Solo lectura; viene del catálogo oficial.' },
          { label: 'Descripción', description: 'Texto para identificarlo en tu empresa. Obligatoria.' },
          { label: 'Tipo AFIP', description: 'Solo en conceptos AFIP; se completa al elegir del catálogo (no editable).' },
        ],
        paragraphs: [
          'No podés repetir un código ya habilitado. Los ítems ya agregados no aparecen en la búsqueda.',
        ],
      },
      {
        title: 'Paso 3 — Editar',
        fields: [
          { label: 'Código AFIP', description: 'No se puede cambiar.' },
          { label: 'Descripción', description: 'Podés ajustarla.' },
          { label: 'Habilitado', description: 'Desactivá si ya no usás ese código (no se borra del historial).' },
        ],
      },
      {
        title: 'Dónde se usan',
        paragraphs: [
          'Obra social habilitada → datos previsionales del empleado y registro 04 al exportar LSD.',
          'Concepto AFIP habilitado → campo «Concepto AFIP (LSD)» y marcas de bases en Laboral → Conceptos; alimentan el TXT de relación de conceptos.',
        ],
      },
    ],
  },
}
